import {ActivatedRoute, ActivatedRouteSnapshot, NavigationExtras, Router} from '@angular/router';

export class RouterHelpers {
  static navigate(router: Router, commands: any[], extras?: NavigationExtras) {

    // Alternative:
    // this.router.navigateByUrl('/', {skipLocationChange: true})
    //   .then(()=>this.router.navigate([<route>]));

    const prev = router.routeReuseStrategy.shouldReuseRoute;
    router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
    router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      router.navigate(commands, extras)
        .finally(() => {
          router.routeReuseStrategy.shouldReuseRoute = prev;
          return router;
        })
        .catch(reason => {
          console.error(reason);
          throw Error(reason);
        });
    });


  }

  static getCombinedData(route: ActivatedRouteSnapshot) {
    let combinedData = {...route.data};
    for (let child of route.children) {
      // Recursively combine data for child routes and merge it
      let childCombinedData = this.getCombinedData(child);
      combinedData = {...combinedData, ...childCombinedData};
    }

    return combinedData;
  }
}
